function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateQuestion(difficulty, operations, correctCount = 0) {
  const op = operations[Math.floor(Math.random() * operations.length)];
  let a, b, answer, explanation;

  // Progressive difficulty: numbers scale up as player gets more correct
  const boost = Math.min(Math.floor(correctCount / 3), 5);

  if (difficulty === 'easy') {
    const maxNum = 9 + boost * 3;
    switch (op) {
      case '+': a = randInt(1, maxNum); b = randInt(1, maxNum); answer = a + b; break;
      case '-': a = randInt(2, maxNum); b = randInt(1, a); answer = a - b; break;
      case '\u00d7': a = randInt(1, 5 + boost); b = randInt(1, 5 + boost); answer = a * b; break;
      case '\u00f7': b = randInt(1, 5 + boost); answer = randInt(1, 5 + boost); a = b * answer; break;
      default: a = randInt(1, maxNum); b = randInt(1, maxNum); answer = a + b;
    }
  } else if (difficulty === 'medium') {
    const maxNum = 50 + boost * 15;
    switch (op) {
      case '+': a = randInt(10, maxNum); b = randInt(10, maxNum); answer = a + b; break;
      case '-': a = randInt(20, maxNum + 49); b = randInt(10, a - 1); answer = a - b; break;
      case '\u00d7': a = randInt(2, 12 + boost); b = randInt(2, 9 + boost); answer = a * b; break;
      case '\u00f7': b = randInt(2, 9 + boost); answer = randInt(2, 12 + boost); a = b * answer; break;
      default: a = randInt(10, maxNum); b = randInt(10, maxNum); answer = a + b;
    }
  } else {
    const maxNum = 999 + boost * 200;
    switch (op) {
      case '+': a = randInt(100, maxNum); b = randInt(100, maxNum); answer = a + b; break;
      case '-': a = randInt(200, maxNum); b = randInt(100, a - 1); answer = a - b; break;
      case '\u00d7': a = randInt(11, 25 + boost * 3); b = randInt(11, 25 + boost * 3); answer = a * b; break;
      case '\u00f7': b = randInt(3, 15 + boost * 2); answer = randInt(3, 20 + boost * 2); a = b * answer; break;
      default: a = randInt(100, maxNum); b = randInt(100, maxNum); answer = a + b;
    }
  }

  // Generate explanation for math questions
  const opWord = { '+': 'tambah', '-': 'tolak', '\u00d7': 'darab', '\u00f7': 'bahagi' };
  explanation = `${a} ${opWord[op] || op} ${b} = ${answer}`;

  return {
    a, b, op,
    answer: answer.toString(),
    display: `${a} ${op} ${b} = ?`,
    explanation_bm: explanation,
    explanation_en: explanation,
  };
}

export function formatTime(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}
